import { Modal } from "react-bootstrap";
import React from "react";
import UnitType from "./UnitType";
import Descriptor from "../../features/rapidstor/entities/Descriptor";
import Header from "../Header";
import SmallDetail from "../SmallDetail";
import PhotoGallery from "./PhotoGallery";
import { Link } from "react-router-dom";
import classes from "./UnitTypeModal.module.scss";

interface Props {
  show: boolean;
  onHide: () => void;
  onBookUnitClicked?: () => void;
  onEmailQuoteClicked?: () => void;
  locationSlug: string;
  unitType: UnitType;
  descriptor: Descriptor;
}

function UnitTypeModal({
  show,
  onHide,
  locationSlug,
  onBookUnitClicked,
  onEmailQuoteClicked,
  unitType,
  descriptor,
}: Props) {
  const images = [descriptor.picture, ...descriptor.slides];

  return (
    <Modal show={show} onHide={onHide} centered className={classes.modal}>
      <Modal.Body className={"d-flex flex-column gap-1" + classes.modal_content}>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onHide}
        ></button>
        <div className="row">
          <div className="col-sm-12 col-md-6">
            <Header level={3} bold className={"text-primary"}>
              Unit Details
            </Header>
            <Header level={2} className={classes.storage_title}>
              {unitType.typeName}
            </Header>
            <div className={"d-flex column-gap-3"}>
              <SmallDetail bold>Unit Size:</SmallDetail>
              <SmallDetail>Length: {unitType.length}m</SmallDetail>
              <SmallDetail>Width: {unitType.width}m</SmallDetail>
              <SmallDetail>Area: {unitType.area}m²</SmallDetail>
            </div>
            <div className={"my-2"}>
              <PhotoGallery images={images} />
            </div>
          </div>
          <div className="col-sm-12 col-md-6">
            <div className={classes.infoBlock}>
              <SmallDetail bold>What is this unit commonly used for?</SmallDetail>
              <p className={classes.answer}>{descriptor.description}</p>
            </div>
            {/*
            <div className={classes.infoBlock}>
              <SmallDetail bold>How do I access the unit?</SmallDetail>
              <p className={`${classes.answer} lorem-ipsum`}>
                Lorem ipsum dolor sit amet consectetur. Ornare nec leo.
              </p>
            </div>
            */}
            {unitType.deal && unitType.deal.descriptions.length > 0 && (
              <div className={classes.infoBlock}>
                <SmallDetail bold>Unit Features</SmallDetail>
                <ul className={classes.answer}>
                  {unitType.deal.descriptions.map((desc, index) => (
                    <li key={index}>{desc}</li>
                  ))}
                </ul>
              </div>
            )}
            {/*
            <div className={classes.infoBlock}>
              <SmallDetail bold>Unsure of size?</SmallDetail>
              <p className={`${classes.answer} lorem-ipsum`}>
                Lorem ipsum dolor sit amet consectetur. Nulla odio vulputate arcu in vitae.
                Aliquam porttitor a dignissim
              </p>
            </div>
            */}
            <div className={classes.buttons}>
              <div className="d-flex gap-3 my-4">
                {unitType.totalAvailable > 0 ? (
                  <button
                    type="button"
                    style={{ fontSize: 14 }}
                    onClick={onBookUnitClicked}
                    className="btn-md w-100 btn btn-primary"
                  >
                    Book Now
                  </button>
                ) : (
                  <Link className="w-100" to={`/contact/${locationSlug}`}>
                    <button
                      type="button"
                      style={{ fontSize: 14 }}
                      className="btn-md w-100 btn btn-primary"
                    >
                      Call For Availability
                    </button>
                  </Link>
                )}
                <button
                  type="button"
                  style={{ fontSize: 14 }}
                  onClick={onEmailQuoteClicked}
                  className="btn-md w-100 btn bg-white btn-outline-primary"
                >
                  Email Quote
                </button>
              </div>
            </div>
            {/*{onBookUnitClicked && (
              <Button className={"btn-md"} onClick={onBookUnitClicked}>
                Book Online
              </Button>
            )}
            {onEmailQuoteClicked && (
              <Button className={"btn-md w-100 btn bg-white btn-outline-primary"} onClick={onEmailQuoteClicked}>
                Email Quote
              </Button>
            )}*/}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default UnitTypeModal;
